import { render, staticRenderFns } from "./ordersApp.vue?vue&type=template&id=5198ccf7&"
import script from "./ordersApp.vue?vue&type=script&lang=js&"
export * from "./ordersApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports